import { ICompetitionRanking, CompetitionRanking } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { CompetitionRankingQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<CompetitionRankingQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<CompetitionRankingQuery>): ICompetitionRanking => {
  return transformer(props);
}

const CompetitionRankingWidget = ({
  props,
  ...rest
}: WidgetContext<ICompetitionRanking>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <CompetitionRanking {...props} />
    </div>
  );
}

export default CompetitionRankingWidget;